import { useImageComponent } from '../../providers/ImageComponentProvider.js';
import { jsx } from 'react/jsx-runtime';
function ImageBase({
  src = '',
  alt = 'image',
  width = 1000,
  height = 1000,
  priority,
  loading,
  className
}) {
  const ImageComponent = useImageComponent();
  if (!src) return null;
  return (/*#__PURE__*/
    // eslint-disable-next-line @cbhq/react-no-nested-component -- TODO Fix this
    jsx(ImageComponent, {
      src: src,
      alt: alt,
      width: width,
      height: height,
      priority: priority,
      loading: loading,
      className: className
    })
  );
}
export { ImageBase };
//# sourceMappingURL=ImageBase.js.map
